import { AnswerState } from "../../game-state/game-state.slice";

export const ProgressBar = (props: { answerState: AnswerState }) => {
  return (
    <div className="bg-white sm:rounded-t p-8">
      <div className="overflow-hidden h-4 flex rounded bg-blue-200">
        <div
          style={{
            transition: "width 0.5s",
            width:
              100 * (props.answerState.correct / props.answerState.total) + "%",
          }}
          className="bg-green-500 flex justify-end"
        >
          {props.answerState.correct / props.answerState.total < 1 ? (
            <div className="w-1 h-full bg-white" />
          ) : null}
        </div>
        <div
          style={{
            transition: "width 0.5s",
            width:
              100 * (props.answerState.incorrect / props.answerState.total) +
              "%",
          }}
          className="bg-red-500 flex justify-end"
        >
          {" "}
          {(props.answerState.correct + props.answerState.incorrect) /
            props.answerState.total <
          1 ? (
            <div className="w-1 h-full bg-white" />
          ) : null}
        </div>
      </div>
    </div>
  );
};
